import { _t } from "app/i18n/i18n";
import { FaIcon } from "lib/FaIcon";
import { noop } from "lib/utils";
import React from "react";
import { Button } from "react-bootstrap";
import { useIsSubscribedToAnalyst } from "../api/subscribeToAnalyst";

export const AnalystSubscribeButton = (analyst) => {
  const [state, changeSubscription] = useIsSubscribedToAnalyst(analyst);

  const onSubscribe = () => changeSubscription(true);
  const onUnsubscribe = () => changeSubscription(false);

  if (state.isLoading) return <LoadingButton />;
  else if (state.err) return <ErrorButton />;

  return state.isSubscribed ? <UnsubscribeButton onClick={onUnsubscribe} /> : <SubscribeButton onClick={onSubscribe} />;
};

const SubscribeButton = ({ onClick }) => CreateButton({ onClick: onClick, icon: "fa-user-plus", label: "Subscribe" });
const UnsubscribeButton = ({ onClick }) =>
  CreateButton({ onClick: onClick, icon: "fa-bell-slash", label: "Unsubscribe" });
const LoadingButton = () => CreateButton({ icon: "fa-spinner fa-spin", label: "Subscribe" });
const ErrorButton = () => CreateButton({ icon: "fa-lock", label: "Subscribe", footer: "(Subscriptions unavailable)" });

const CreateButton = ({ onClick = noop, icon, label, footer }) => (
  <Button onClick={onClick} variant="secondary p-2 text-white">
    <FaIcon icon={"fa fa-2x mr-1 " + icon} align="top" />
    <div>{_t(label)}</div>
    <small>{footer}</small>
  </Button>
);
